export const LOCATIONS_NAMESPACE = 'locations';

// mutations
export const SET_LOCATIONS = 'setLocations';
export const SET_SUFFIX = 'setSuffix';

// actions
export const GET_LOCATIONS = 'getLocations';

export default {};
